<template>
    <div class="timetableMain w100">
        <div class="mainTable">
            <div  class="title" style="background: #fff">班级课表</div>
            <div class="seachCla findInput">
                <span>
                    学期
                </span>
                <el-select
                        style="width: 250px; margin: 0 10px"
                        @change="semesterClick" v-model="searchObj.semesterId" placeholder="请选择学期">
                    <el-option
                            v-for="item in semesterList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                    </el-option>
                </el-select>
                <el-button type="primary" @click="semesterClick">查询</el-button>
            </div>
            <div class="weekTable">
                <div class="b-week">
                    <div v-for="(item,index) in weekList" :key="index"
                         @click="selectWeek(item)"
                         :class="['c-item',{'activeC-item' : item.weekNo === searchObj.weekNo}]"
                    >
                        <div class="triangle" v-if="item.classFlag == 0">无课</div>
                        <div>第{{item.weekNo}}周</div>
                        <div class="c-time">{{formartDate(item.beginDate,item.endDate)}}</div>
                    </div>
                </div>
            </div>
            <el-row class="tableCenter">
                <el-col style="background-color: #ffffff;padding: 20px;width: 400px;
                display: flex;flex-direction: column;">
                    <div class="findInput justifyContent">
                        <el-input style="width: 280px" v-model="keyword"  @change="getLeftTableData" clearable
                                  placeholder="请输入关键字"></el-input>
                        <el-button type="primary" @click="getLeftTableData">查询</el-button>
                    </div>
                    <el-table
                            style="flex: 1;"
                            ref="leftTable"
                            :data="LeftTableData"
                            highlight-current-row
                            height="100%"
                            @current-change="handleCurrentLeftChange"
                    >
                        <el-table-column width="50" type="index" label="#" align="center"></el-table-column>
                        <el-table-column label="班级名称">
                            <template slot-scope="scope">
                                <span style="cursor: pointer;">{{scope.row.className}}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-col>
                <el-col style="width:calc(100% - 400px);height: 100%">
                    <el-table

                            :data="rightTableData"
                            height="100%"
                            :header-cell-style="setHeaderStyle"
                            :span-method="arraySpanMethod"
                            :cell-class-name="rowNameClass"
                    >
                        <!--<el-table-column width="50" label="&#45;&#45;7" prop="time" align="center">
                            <template slot-scope="scope">
                                <div>{{scope.row.time}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column width="100" label="&#45;&#45;8" prop="numlabel" align="center">
                            <template slot-scope="scope">
                                <div style="padding: 5px 0">
                                    <div>
                                        {{scope.row.numlabel}}
                                    </div>
                                    <div v-if="scope.row.startTime">
                                        {{scope.row.startTime}}-{{scope.row.endTime}}
                                    </div>
                                </div>
                            </template>
                        </el-table-column>-->
                        <el-table-column width="50" label="时间/节次" align="center">
                            <el-table-column width="50" label="" prop="time" align="center">
                                <template slot-scope="scope">
                                    <div>{{scope.row.time}}</div>
                                </template>
                            </el-table-column>
                            <el-table-column width="100" label="" prop="numlabel" align="center">
                                <template slot-scope="scope">
                                    <div style="padding: 5px 0">
                                        <div>
                                            {{scope.row.numlabel}}
                                        </div>
                                        <div v-if="scope.row.startTime">
                                            {{scope.row.startTime}}-{{scope.row.endTime}}
                                        </div>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table-column>

                        <el-table-column
                                :label="oneLabel.label"
                                align="center"
                                v-for="(oneLabel,index) in headerData"
                                :prop="oneLabel.id"
                                :key="index">
                            <template slot-scope="scope">

                                <div class="tingke">
                                    <el-tooltip
                                            v-if="scope.row[oneLabel.id]"
                                            placement="top"
                                            effect="light"
                                    >
                                        <div slot="content">
                                            {{scope.row[oneLabel.id+"isAdjust"]!=0?"[调课]":""}}<br/>
                                            {{scope.row[oneLabel.id]}}<br/>
                                            {{scope.row[oneLabel.id+"teacherNme"]}}<br/>
                                            {{scope.row[oneLabel.id+"classroomName"]}}<br/>
                                        </div>
                                        <div class="details">
                                            <div>{{scope.row[oneLabel.id+"isAdjust"]!=0?"[调课]":""}}</div>
                                            <div>{{scope.row[oneLabel.id]}}</div>
                                            <div> {{scope.row[oneLabel.id+"teacherNme"]}}</div>
                                            <div>{{scope.row[oneLabel.id+"classroomName"]}}</div>
                                            <!--{{scope.row[oneLabel.id]}}<br/>
                                            {{scope.row[oneLabel.id+"teacherNme"]}}<br/>
                                            {{scope.row[oneLabel.id+"classroomName"]}}<br/>-->
                                        </div>
                                    </el-tooltip>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table
                    >
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
    import * as api from '@/api/overseasChinese/overseasChinese'

    export default {
        name: "classTimetable",
        data() {
            return {
                semesterList: [],
                searchObj: {
                    semesterId: '',
                    weekNo: 1,
                    classId: ''
                },
                weekList: [],
                headerData: [], // 周一 - 周五处理数据
                listData: [], // 周一 - 周五处理数据
                sumHour: 0,
                keyword: '',
                LeftTableData: [],
                rightTableData: []
            }
        },
        mounted() {
            this.initData()
            // this.getLeftTableData()
        },
        watch: {
            "listData": {
                handler(val) {
                    if (val) {
                        this.rightTableData = val
                    }
                },
                deep: true
            }
        },
        methods: {
            initData() {
                this.tableLoading = true
                this.getSemesterData()
                this.getLeftTableData()
            },
            getSemesterData() {
                api.getSemesterSel().then(({data}) => {
                    this.semesterList = data.data
                    let arr = data.data.find((item) => item.current == 1) || data.data[0]
                    // let arr = data.data.find((item) => item.current == 1) || data.data[7]
                    this.searchObj.semesterId = arr.id
                    this.getSchoolWeek()
                })
            },
            handleCurrentLeftChange(val) {
                if (val) {
                    this.tableLoading = true
                    this.searchObj.classId = val.classId
                    // this.getSchoolWeek()
                    this.getTableList()
                }
            },
            semesterClick() {
                this.getSchoolWeek()
            },
            //获取左侧筛选列表
            getLeftTableData() {
                let params = {
                    keyword: this.keyword,
                    size: 100000,
                }
                api.getClassList(params).then(({data}) => {

                    if (data.code === 0) {
                        this.LeftTableData = data.data.records
                        if (data.data.records.length > 0) {
                            this.searchObj.classId = data.data.records[0].classId
                            let row = data.data.records[0]
                            this.$refs.leftTable.setCurrentRow(row)
                        }

                    } else {
                        this.$alert(data.msg, "提示", {
                            confirmButtonText: "确定",
                            type: "warning"
                        });
                    }

                })
            },
            //获取右侧列表
            getTableList() {
                let listData_new = JSON.parse(JSON.stringify(this.listData))
                // api.getClassTimeTab(this.searchObj).then(({data}) => {
                api.getClassTimeTab_new(this.searchObj).then(({data}) => {
                    this.rightTableData = []
                    if (data.code === 0 && data.data.length > 0) {
                        let resList = data.data
                        listData_new.forEach(e => {
                            for (let i = 0; i < resList.length; i++) {
                                if (e.index === resList[i].index && e.timeType === resList[i].timeType) {
                                    let course = `week${resList[i].day}`
                                    e[course] = resList[i].courseName
                                    e[course + 'teacherNme'] = resList[i].teacherNme
                                    e[course + 'classroomName'] = resList[i].classroom
                                    e[course + 'isAdjust'] = resList[i].isAdjust
                                    e[ 'courseJcs' + (Number(resList[i].day) + 1) ] = resList[i].courseJcs || ''

                                }
                            }
                        })
                        this.rightTableData = listData_new
                    } else if (data.data.length === 0) {
                        this.rightTableData = this.listData
                    }
                    else if (data.code === 1) {
                        this.$alert(data.msg, "提示", {
                            confirmButtonText: "确定",
                            type: "warning"
                        });
                    }
                })
            },
            // 合并表格按照合并节次
            arraySpanMethod({row, column, rowIndex, columnIndex}) {
                if (!columnIndex) {
                    if (rowIndex === row.rowIndex) {
                        return {
                            rowspan: row.numCourse,
                            colspan: 1
                        };
                    } else {
                        return {
                            rowspan: 0,
                            colspan: 0
                        };
                    }
                }
                if(columnIndex > 1){
                    if (row[`courseJcs${columnIndex}`] > '1'  ) {
                        return {
                            rowspan: row[`courseJcs${columnIndex}`] ,
                            colspan: 1
                        };
                    } else {
                        // console.log(66,columnIndex);
                        return {
                            rowspan: 1,
                            colspan: 1
                        };
                    }
                }
            },
            // 表头样式
            setHeaderStyle({row, column, rowIndex, columnIndex}) {
                if (rowIndex === 0 && columnIndex === 0) {
                    this.$nextTick(() => {
                        if (document.getElementsByClassName(column.id).length !== 0) {
                            document.getElementsByClassName(column.id)[0].setAttribute('rowSpan', 2);
                            return false
                        }
                    })
                }
                if (rowIndex === 1 && (columnIndex === 0 || columnIndex === 1)) {
                    return {display: 'none'}
                }
            },
            // 左边颜色
            rowNameClass({row, column, rowIndex, columnIndex}) {
                if (columnIndex === 0 || columnIndex === 1) {
                    if (row.timeType === "am") {
                        return 'shangWu';
                    } else if (row.timeType === "pm") {
                        return 'xiaWu';
                    } else if (row.timeType === "night") {
                        return 'wanShang';
                    }
                    if (row.timeType === "morning") {
                        return 'zaozixi';
                    } else if (row.timeType === "noon") {
                        return 'zhongwu';
                    } else if (row.timeType === "evening") {
                        return 'wanzixi';
                    } else {
                        return ''
                    }
                }
            },
            formartDate(startTime, endTime) {
                return `${startTime.substring(5)} ~ ${endTime.substring(5)}`
            },
            // 获取周列表
            getSchoolWeek() {
                if (this.searchObj.semesterId) {
                    let params = {
                        semesterId: this.searchObj.semesterId,
                    };
                    this.tableLoading = true
                    api.getWeekSel(params).then(({data}) => {
                        if (data.code === 0) {
                            this.weekList = data.data
                            // this.searchObj.weekNo = data.data[0].weekNo
                            // this.getHeaderNew(data.data[0].beginDate)
                            let years = this.$moment().get('year')
                            let month = this.$moment().get('month') + 1
                            if(month>12){
                                month =1
                            }
                            let day = this.$moment().get('date')
                            let time = `${years}/${month}/${day}`;
                            let weekStartTime = "";
                            data.data.forEach(i=>{
                                if(new Date(time)>=new Date(i.beginDate)&&new Date(time)<=new Date(i.endDate)){
                                    this.searchObj.weekNo = i.weekNo;
                                    weekStartTime = i.beginDate
                                }
                            })
                            this.getHeaderNew(weekStartTime)
                        } else {
                            this.$alert(data.msg, "提示", {
                                confirmButtonText: "确定",
                                type: "warning"
                            });
                        }
                    })
                        .catch(() => {
                            this.tableLoading = false;
                        });
                }
            },
            selectWeek(item) {
                this.searchObj.weekNo = item.weekNo
                this.getTableList();
            },
            getHeaderNew(time) {
                this.headerData = []
                this.listData = []
                this.sumHour = 0
                let params = {
                    semesterId: this.searchObj.semesterId,
                    weekStartTime: time,
                }
                api.getTimeTabWeek(params).then(({data}) => {
                    if (data.code === 0) {
                        let times = data.data.times
                        let infos = data.data.infos
                        let leftArr = []
                        let keysTime = Object.keys(times)
                        let new_timeArr = [] // 处理按顺序储存
                        let timeArrType = ['morning', 'am', 'noon', 'pm', 'night', 'evening']
                        for (let i = 0; i < timeArrType.length; i++) {
                            if (keysTime.indexOf(timeArrType[i]) > -1) {
                                new_timeArr.push(timeArrType[i])
                            }
                        }
                        for (let item of new_timeArr) {
                            for (let j = 0; j < infos.length; j++) {
                                if (item === infos[j].type) {
                                    let amObj = {
                                        rowIndex: JSON.parse(JSON.stringify(this.sumHour)),
                                        numlabel: `第${j + 1}节`,
                                        time: this.handleLabel(item),
                                        numCourse: times[item].length,
                                        timeType: item,
                                        endTime: infos[j].endTime,
                                        index: infos[j].index,
                                        startTime: infos[j].startTime,
                                        type: item,
                                    }
                                    leftArr.push(amObj)
                                }
                            }
                            this.sumHour += times[item].length
                        }
                        this.listData = leftArr
                        // 头部
                        for (let i = 0; i < 7; i++) {
                            let o = {
                                label: this.handleLabel(i + 1),
                                id: `week${i + 1}`,
                            }
                            this.headerData.push(o)
                        }
                    } else {
                        this.$alert(data.msg, "提示", {
                            confirmButtonText: "确定",
                            type: "warning"
                        });
                    }

                })
            },
            handleLabel(num) {
                switch (num) {
                    case 1:
                        return "周一";
                    case 2:
                        return "周二";
                    case 3:
                        return "周三";
                    case 4:
                        return "周四";
                    case 5:
                        return "周五";
                    case 6:
                        return "周六";
                    case 7:
                        return "周日";
                    case 'morning':
                        return '早自习';
                    case 'am':
                        return '上午';
                    case 'noon':
                        return '中午';
                    case 'pm':
                        return '下午';
                    case 'night':
                        return '晚上';
                    case 'evening':
                        return '晚自习';
                    default:
                        return "";
                }
            }
            ,
        }
    }
</script>
<style lang="less">
    .el-table {
        .shangWu {
            background: #DDC7ED !important;
        }
        .xiaWu {
            background: #AEE3D8 !important;
        }
        .wanShang {
            background: #F1DEC0 !important;
        }
        .zaozixi {
            background: #AEE3D8;
        }
        .zhongwu {
            background: #F1DEC0;
        }
        .wanzixi {
            background: #DDC7ED;
        }
    }
</style>
<style scoped lang="less">
    .seachCla {
        padding: 20px 20px 10px 20px;
        background-color: #ffffff;
    }

    .timetableMain {
        height: 100% ;
        .mainTable {
            padding-bottom: 20px;
            width: 100%;
            height: 100%;
            background-color: #EFF0F4;
            display: flex;
            flex-direction: column;
            .tableCenter {
                margin-top: 2px;
                display: flex;
                align-content: center;
                flex: 1;
                overflow: hidden;
            }
        }
    }

    .tingke {
        font-size: 14px;
        .details {
            > div {
                width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }

    }

    .findInput {
        display: flex;
        align-items: center;
        /*justify-content: space-between;*/
    }

    .justifyContent {
        justify-content: space-between;
    }

    .b-week {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        flex-direction: row;
        padding-left: 10px;
        padding-right: 0;
        padding-top: 12px;
        align-content: flex-start;
        background: #fff;
        border-bottom: 1px solid #E4E7ED;
        .c-item {
            position: relative;
            overflow: hidden;
            cursor: pointer;
            width: 100px;
            margin-right: 12px;
            margin-bottom: 12px;
            padding: 5px;
            background-color: #F5F7FA;
            border: 1px solid #F5F7FA;
            text-align: center;
            .triangle {
                position: absolute;
                background: #E4E4E4;
                color: #6F6F6F;
                right: -18px;
                top: -2px;
                padding-left: 13px;
                padding-right: 15px;
                padding-top: 6px;
                font-size: 12px;
                transform: rotate(45deg);
            }
        }
        .activeC-item {
            border-color: #409EFF;
            color: #409EFF;
            background: #fff;
        }
    }
</style>